// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"114":"f06c63d1","161":"d92ef79c","239":"e7a2ff17","241":"190acb2b","355":"457fb329","396":"4bebed1f","455":"f729acf8","673":"26b0d133","715":"73b3a51e","722":"c4662f89","857":"44e4468d","882":"9d61039e","889":"0f44194e","977":"a723575a"}[chunkId] + ".chunk.js";
};